import React, { useCallback, useContext, useEffect, useState } from "react";
import { styled } from "styled-components";
import { Checkbox, Box } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import InputField from "../../components/Layout/InputField";
import Button from "../../components/Layout/Button";
import DataTable from "../../components/Layout/Table/DataTable";
import {
  ExistingText,
  OuterContainerStyles,
  SearchContainerTable,
  Title,
} from "../../components/Layout/Typography";
import Heading from "../../components/Layout/Heading";
import { SERVICES } from "../../components/Layout/Services";
import fetchData from "../../components/Layout/FetchData";
import {
  del,
  post,
  get,
  put,
} from "../../components/Layout/ApiHandler/apihandler";
import EditModal from "../../components/Layout/Modal";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader/Loader";
import EditIcon from "../../components/Svg/EditIcon";
import DeleteIcon from "../../components/Svg/DeleteIcon";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import Alert from "../../components/Alert/Alert";

const Text = styled.p`
  color: #484848;
  font-size: 16px;
  font-weight: 400;
  line-height: 125%;
  margin: 0 0;
`;
const FieldWrapper = styled.div`
  display: flex;
  padding-left: 95px;
  align-items: center;
  gap: ${(props) => props.customGap || "10px"};
  align-self: stretch;
`;

function ReceiptTypes() {
  const TITLE = "Receipt Type Details - BSG ContributionAdmin";
  const [searchText, setSearchText] = useState("");
  const [receiptData, setReceiptData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [selectedReceiptId, setSelectedReceiptId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [nameOfReceipt, setNameOfReceipt] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  // const [receiptId, setReceipId] = useState("");
  // const [individualReceiptData, setIndividualReceiptData] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [openAlert, setOpenAlert] = useState(false);

  const handleAlertClose = () => {
    setOpenAlert(false);
  };
  const handleEdit = (event) => {
    setEdit(event.target.value);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleReceipt = (event) => {
    setNameOfReceipt(event.target.value);
  };
  const getReceiptById = async (receiptId) => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}/${receiptId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setEdit(data.data.name);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleEditReceipt = async (receiptId) => {
    setSelectedReceiptId(receiptId);
    getReceiptById(receiptId);
    setIsModalOpen(true);
  };

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleDeleteAlert = (receiptId) => {
    setSelectedReceiptId(receiptId);
    setOpenAlert(true);
  };

  const fetchReceiptData = useCallback(async () => {
    const url = SERVICES.RECEIPT_TYPES;
    await fetchData(url, setReceiptData, setIsLoading);
  }, []);

  const resetvalues = () => {
    setNameOfReceipt("");
    setIsDefault(false);
  };

  const handleSubmitForm = async () => {
    if (nameOfReceipt.trim() === "") {
      return;
    }
    try {
      const url = SERVICES.RECEIPT_TYPES;
      const response = await post(url, {
        name: nameOfReceipt,
        status: "ACTIVE",
        defaultValue: isDefault,
      });
      if (response.ok) {
        toast.show("Receipt Added Successfully", AlertStatus.SUCCESS);
        // console.log("Form submitted successfully");
        await fetchReceiptData();
        setNameOfReceipt("");
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        console.error("Failed to submit the form");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleEditSubmit = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}/${selectedReceiptId}`;
      const data = {
        name: edit.trim(),
      };

      const response = await put(url, data);

      if (response.ok) {
        await fetchReceiptData();
        toast.show("Receipt Updated Successfully", AlertStatus.SUCCESS);
        closeModal();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleDeleteReceipt = async (receiptId) => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}/${receiptId}`;
      const response = await del(url);
      if (response.ok) {
        toast.show("Receipt Deleted Successfully", AlertStatus.SUCCESS);
        await fetchReceiptData();
        handleAlertClose();
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  // const handleSearch = async () => {
  //   console.log(searchText.trim());
  //   if (searchText.trim() === "") {
  //     return;
  //   }
  //   // const foundReceipt = receiptData.receiptTypes.find(
  //   //   (el) => el.name === searchText.trim(),
  //   // );
  //   const foundReceipt = receiptData.receiptTypes.find((el) =>
  //     el.name.toLowerCase().includes(searchText.trim().toLowerCase()),
  //   );
  //   console.log(foundReceipt);
  //   if (foundReceipt) {
  //     // setSelectedReceiptId(foundReceipt.id);
  //     try {
  //       const url = `${SERVICES.RECEIPT_TYPES}/${foundReceipt.id}`;
  //       const response = await get(url);
  //       console.log(response);
  //       if (response.ok) {
  //         const data = await response.json();
  //         const receiptDataArray = [data.data];
  //         setIndividualReceiptData(receiptDataArray);
  //       } else {
  //         console.error("Failed to fetch receipt data");
  //       }
  //     } catch (error) {
  //       console.error("Error", error);
  //     }
  //   } else {
  //     setSelectedReceiptId(null);
  //     toast.show("Receipt Type not Found", AlertStatus.ERROR);
  //   }
  // };
  const handleSearch = async () => {
    // console.log(searchText.trim());
    if (searchText.trim() === "") {
      fetchReceiptData();
      return;
    }
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const filteredData = data.data.receiptTypes.filter((item) =>
          item.name.toLowerCase().includes(searchText.toLowerCase()),
        );
        if (filteredData.length === 0) {
          toast.show("Receipt Type not found", AlertStatus.ERROR);
        } else {
          setReceiptData({ receiptTypes: filteredData });
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    fetchReceiptData();
  }, [fetchReceiptData]);

  useEffect(() => {
    if (receiptData.receiptTypes) {
      const updatedTableData = receiptData.receiptTypes.map((item, index) => {
        return {
          id: item.id,
          column1: index + 1,
          column2: item.name,
          column3: item.defaultValue ? "Y" : "N",
          column4: (
            <div
              style={{ display: "flex", gap: "25px", justifyContent: "center" }}
            >
              <EditIcon
                onClick={() => handleEditReceipt(item.id)}
                style={{ cursor: "pointer" }}
              />
              <DeleteIcon
                // onClick={() => handleDeleteReceipt(item.id)}
                onClick={() => handleDeleteAlert(item.id)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [receiptData.receiptTypes]);

  // useEffect(() => {
  //   if (individualReceiptData.length > 0) {
  //     const updatedTableData = individualReceiptData.map((item, index) => {
  //       return {
  //         id: item.id,
  //         column1: index + 1,
  //         column2: item.name,
  //         column3: item.defaultValue ? "Y" : "N",
  //         column4: (
  //           <div
  //             style={{ display: "flex", gap: "25px", justifyContent: "center" }}
  //           >
  //             <EditIcon
  //               onClick={() => handleEditReceipt(item.id)}
  //               style={{ cursor: "pointer" }}
  //             />
  //             <DeleteIcon
  //               // onClick={() => handleDeleteReceipt(item.id)}
  //               onClick={() => handleDeleteAlert(item.id)}
  //               style={{ cursor: "pointer" }}
  //             />
  //           </div>
  //         ),
  //       };
  //     });

  //     setTableData(updatedTableData);
  //   }
  // }, [individualReceiptData]);

  // console.log(receiptData);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const tableHeaders = ["S. No.", "Receipt Name", "Default", "Action"];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Receipt Type Details" />
      <OuterContainerStyles>
        <Title>Receipt Type Details</Title>
        <FieldWrapper customGap="90px">
          <Text>On Account of</Text>
          <InputField onChange={handleReceipt} customvalue={nameOfReceipt} />
        </FieldWrapper>
        <FieldWrapper customGap="140px">
          <Text>Default</Text>
          <Checkbox
            checked={isDefault}
            onChange={(event) => setIsDefault(event.target.checked)}
          />
        </FieldWrapper>
        <Box sx={{ display: "flex", gap: "25px", padding: "0 50px 30px 0" }}>
          <Box sx={{ flexGrow: 1 }} />
          <Button cancel onClick={resetvalues} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleSubmitForm} disabled={isLoading}>
            submit
          </Button>
        </Box>
      </OuterContainerStyles>
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <ExistingText>Existing Receipt Type</ExistingText>
        <SearchContainerTable>
          <div style={{ width: "50%" }}>
            <InputField
              onChange={handleInputChange}
              placeholder="Search here..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </div>
          <Button onClick={handleSearch}>Search</Button>
          <Btn type="button" onClick={fetchReceiptData}>
            View All
          </Btn>
        </SearchContainerTable>
        {tableData?.length ? (
          <DataTable data={tableData} headers={tableHeaders} />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
      </OuterContainerStyles>
      <EditModal
        isOpen={isModalOpen}
        handleClose={closeModal}
        onChange={handleEdit}
        handleSubmit={handleEditSubmit}
        heading="Edit Receipt"
        placeholder="Enter Receipt Name ..."
        initialValue={edit}
      />
      <Alert
        open={openAlert}
        onClose={handleAlertClose}
        onSubmit={() => handleDeleteReceipt(selectedReceiptId)}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default ReceiptTypes;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;
